import { supports } from "../data";
import { PageIntro } from "../components/Shell";
import { TimelineList } from "../components/Records";

export default function ProjectsPage() {
  return (
    <>
      <PageIntro
        label="Research support"
        title="연구 지원"
        aside={
          <>
            확인된 연구지원 기록 · {supports.length}
            <br />
            기간과 지원기관 기준
          </>
        }
      />
      <section className="page-section shell">
        <TimelineList records={supports} headingLevel={2} />
      </section>
    </>
  );
}
